import { createFileRoute } from "@tanstack/react-router";
import {
  Page,
  PageHeader,
  AddButtonGroup,
  Box,
} from "@flukecorp-emu/common-ui";
import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { PublicProductsGrid } from "../../components/Catalog";
import { getPublicProducts } from "../../services/catalogManager";

export const Route = createFileRoute("/_authenticated/catalog")({
  component: Catalog,
});

function Catalog() {
  const { enqueueSnackbar } = useSnackbar();

  // Fetch public products using React Query
  const {
    data: products = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["publicProducts"],
    queryFn: getPublicProducts,
    onError: (error) => {
      enqueueSnackbar(error?.message || "Failed to fetch public products", {
        variant: "error",
      });
    },
  });

  const handleCreate = () => {
    enqueueSnackbar("Create product functionality coming soon", {
      variant: "info",
    });
  };

  const styles = {
    header: {
      minHeight: "5rem",
      borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
    },
  };

  return (
    <Box data-testid="catalog-page">
      <Page
        disableGutters
        title="Catalog"
        data-testid="catalog-page-main"
        pageHeight={"90vh"}
        pageHeader={
          <PageHeader
            hideMoreButton={true}
            position="sticky"
            title="Public Products"
            sx={styles.header}
            data-testid="catalog-page-header"
            action={
              <AddButtonGroup
                hideButtonDropdown={true}
                label="Create New Product"
                onClick={handleCreate}
                data-testid="catalog-create-button"
              />
            }
          />
        }
      >
        <PublicProductsGrid
          isLoading={isLoading}
          products={products}
          handleCreate={handleCreate}
        />
      </Page>
    </Box>
  );
}
